'use strict';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AdFoxFactory from '../AdFox/AdFoxFactory';
import { ADFOX } from '../../consts';

class AdFoxTile extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isLoaded: false,
      isError: false,
      stub_1: false,
      stub_2: false,
      stub_3: false,
      stub_4: false,
      stub_5: false,
      stub_6: false
    };

    this.onRender = this.onRender.bind(this);
    this.onError = this.onError.bind(this);
    this.onStub = this.onStub.bind(this);
  }

  onRender () {
    this.setState({
      isLoaded: true
    });
  }

  onError () {
    this.setState({
      isError: true
    });
  }

  onStub (index) {
    const state = Object.assign({}, this.state);
    state['stub_' + index] = true;

    if (state.stub_1 && state.stub_2 && state.stub_3 && state.stub_4 && state.stub_5 && state.stub_6) {
      state.isError = true;
    }

    this.setState(state);
  }

  componentDidMount () {
    if (!(window.Ya && window.Ya.adfoxCode)) {
      this.onError();
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    window.Ya && window.Ya.adfoxCode && window.Ya.adfoxCode.clearSession();
  }

  render () {
    if (this.state.isError) {
      return null;
    }

    const {dealType, realtyType, regionName} = this.props;
    const adFoxList = {};

    for (let i = 1; i <= 6; i += 1) {
      adFoxList['adFoxEl' + i] = AdFoxFactory(regionName).getBySection(ADFOX.homeBuilder, dealType, realtyType,
        {
          index: i,
          onRender: this.onRender,
          onError: this.onError,
          onStub: () => this.onStub(i)
        }
      );
    }
    return (
      <div className='builder-suggestion'>
        {
          this.state.isLoaded && <h3 className='builder-suggestion__title'>Спецпредложения от застройщиков</h3>
        }
        {
          !this.state.isLoaded && (
            <div className='ajax-waiting-overlay'>
              <div className='radial-progress'>
                <div className='circle'>
                  <div className='fill' />
                </div>
              </div>
            </div>
          )
        }

        <div className='tile_wrp'>
          {
            !this.state.stub_1 && (
              <div className='tile tile-1'>
                {adFoxList.adFoxEl1}
              </div>
            )
          }{
            !this.state.stub_2 && (
              <div className='tile tile-2'>
                {adFoxList.adFoxEl2}
              </div>
            )
          }{
            !this.state.stub_3 && (
              <div className='tile tile-3'>
                {adFoxList.adFoxEl3}
              </div>
            )
          }{
            !this.state.stub_4 && (
              <div className='tile tile-4'>
                {adFoxList.adFoxEl4}
              </div>
            )
          }{
            !this.state.stub_5 && (
              <div className='tile tile-5'>
                {adFoxList.adFoxEl5}
              </div>
            )
          }{
            !this.state.stub_6 && (
              <div className='tile tile-6'>
                {adFoxList.adFoxEl6}
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

AdFoxTile.propTypes = {
  regionName: PropTypes.string.isRequired,
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired
};
AdFoxTile.defaultProps = {};

export default AdFoxTile;



// WEBPACK FOOTER //
// ./src/ui/Widgets/AdFoxTile.jsx